<template>
    <div>
        <my-pages-header></my-pages-header>
        <my-pages-menu :routes="menuRoutes"></my-pages-menu>
        <router-view
            v-if="!isLoading && !error"
            :isCustomer="isCustomer"
            :customerUserData="customerData.User"
            :customerRequests="customerData.Requests">
        </router-view>
        <loader class="c-m-loader--large" v-else-if="isLoading"></loader>
        <error-state v-else-if="error"></error-state>
    </div>
</template>
<script>

    import { mapGetters } from 'vuex';
    import {
        GET_CUSTOMER_DATA,
        IS_LOADING,
        GET_ERROR
    } from '../store/store-models/my-pages-customer-model';

    import MyPagesMenu from './components/molecules/MoleculeMyPagesMenu.vue';
    import MyPagesHeader from './components/organisms/my-pages-sections/OrganismMyPagesHeader';
    import Loader from './components/molecules/MoleculeLoader.vue';
    import ErrorState from './components/molecules/MoleculeErrorState.vue';

    export default {
        components:{
            MyPagesMenu,
            MyPagesHeader,
            Loader,
            ErrorState
        },
        props: [
            'isCustomer'
        ],
        data() {
            return {
                menuRoutes: [],
            }
        },
        computed: {
            ...mapGetters({
                isLoading: IS_LOADING,
                error: GET_ERROR,
                customerData: GET_CUSTOMER_DATA
            })
        },
        methods: {
            assignMenuByRole() {
                this.$router.options.routes.forEach(route => {
                    if(route.path === '/mina-sidor' && route.children){
                        route.children.forEach(children => {
                            if( children.name !== 'Mina Sidor' && children.meta.role.includes('Customer') ) {
                                this.menuRoutes.push({
                                    name: children.name,
                                    path: children.path
                                })
                            }
                        })
                    }
                })
            }
        },
        created() {
            this.assignMenuByRole();
        },
    }

</script>





// WEBPACK FOOTER //
// src/views/MyPagesCustomer.vue